import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
    Row,
    Col,
    Spinner,
    Button,
    Input,
    ModalHeader,
    Modal,
    ModalBody,
    Form,
    Label,
} from "reactstrap"
import { withRouter } from "react-router"
import Select from "react-select"
import { Link } from "react-router-dom"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import Switch from "react-switch"
import FileDownload from "js-file-download"
//
const DataTableFicheRenseignement = props => {
    const [loading, setLoading] = useState(false)
    const [arraySelect, setArraySelect] = useState([])
    const [arraySelectAll, setArraySelectAll] = useState([])
    const [orders, setOrders] = useState([])
    const [view, setView] = useState(0);
    const [delet, setDelet] = useState(0);
    const [add, setAdd] = useState(0);
    const pageOptions = {
        loading: true,
        hidePageListOnlyOnePage: true,
        totalSize: orders.length,
        page: 1,
        nextPageText: "Next",
        prePageText: "Back",
        sizePerPage: 100,
        alwaysShowAllBtns: true,
        sizePerPageList: [
            {
                text: "100",
                value: 100,
            },
            {
                text: "150",
                value: 150,
            },
            {
                text: "200",
                value: 200,
            },
            {
                text: "300",
                value: 300,
            },
            {
                text: "All",
                value: orders.length,
            },
        ],
    }

    const NoDataIndication = () => (
        <h6 style={{ textAlign: "center" }}>No record to display</h6>
    )
    const Columns = () => [
        {
            dataField: "cin",
            text: "CIN",
            sort: true,
            style: {
                textAlign: "center",
            },
            headerStyle: (colum, colIndex) => {
                return { textAlign: "center" }
            },
        },
        {
            dataField: "nom_ar",
            text: "Nom et prénom Ar",
            sort: true,
            style: {
                textAlign: "center",
            },
            headerStyle: (colum, colIndex) => {
                return { textAlign: "center" }
            },
        }, {
            dataField: "nom_fr",
            text: "Nom et prénom Fr",
            sort: true,
            style: {
                textAlign: "center",
            },
            headerStyle: (colum, colIndex) => {
                return { textAlign: "center" }
            },
        },
        {
            dataField: "cycle",
            text: "Cycle",
            sort: true,
            style: { textAlign: "center" },
            headerStyle: (colum, colIndex) => {
                return { textAlign: "center" }
            },
        },
        {
            dataField: "niveau",
            text: "Niveau",
            sort: true,
            style: { textAlign: "center" },
            headerStyle: (colum, colIndex) => {
                return { textAlign: "center" }
            },
        },
        {
            dataField: "specialite",
            text: "Spécialité",
            sort: true,
            style: { textAlign: "center" },
            headerStyle: (colum, colIndex) => {
                return { textAlign: "center" }
            },
        },
        // {
        //     dataField: "Consultation",
        //     text: "Consultation",
        //     sort: true,
        //     style: { textAlign: "center" },
        //     headerStyle: (colum, colIndex) => {
        //         return { textAlign: "center" }
        //     },
        //     // eslint-disable-next-line react/display-name
        //     formatter: (cellContent, row) => (
        //         view == 1 ? (
        //             <div style={{display: "flex", justifyContent: "center"}}>
        //                 <Link to={"/DetailEtudiantRenseignement?id=" + row.cin}>
        //                     <i
        //                         style={{color: "mediumslateblue", cursor: "pointer"}}
        //                         className="fas fa-eye"
        //                     ></i>
        //                 </Link>
        //             </div>
        //         ) : (
        //             <div style={{display: "flex", justifyContent: "center"}}>
        //                 <i
        //                     style={{color: "#a7a3a3", cursor: "pointer"}}
        //                     className="fas fa-eye"
        //                 ></i>
        //             </div>
        //         )
        //     ),
        //     center: true,
        //     reorder: true,
        // },

    ]
    const { SearchBar } = Search
    var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
    var annee_id = userAuthScolarite.user.annee_id
    useEffect(async () => {
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
            user.sous_menu.some(subMenu => subMenu.sous_menu === "Etudiants")
        );
        setView(typeArticleSubMenu.sous_menu[0].view)
        setDelet(typeArticleSubMenu.sous_menu[0].delete)
        setAdd(typeArticleSubMenu.sous_menu[0].add)
        const resE = await API.post("renseignement/list",{annee_id}).then(resE => {
            setOrders(resE.data.Renseignements)
            setLoading(true)
        })
    }, [])
    const upload = async () => {
        const res = await API.post(
          "renseignement/export_excel",
          {
              annee_id
          },
          { responseType: "blob" }
        ).then(res => {
            FileDownload(res.data, "listes des étudiants renseignant.xlsx")
        })
    }
    return (
        <React.Fragment>
            <div>
                {loading ? (
                    <Row className="mt-4">
                        <Col xs="12">
                            <ToolkitProvider
                                keyField="id"
                                data={orders}
                                columns={Columns()}
                                search
                                bootstrap4
                            >
                                {toolkitProps => (
                                  <div>
                                      <Row className="mb-2">
                                          <Col sm="4">
                                              <div className="search-box me-2 mb-2 d-inline-block">
                                                  <div className="position-relative">
                                                      <SearchBar {...toolkitProps.searchProps} />
                                                      <i className="bx bx-search-alt search-icon" />
                                                  </div>
                                              </div>
                                          </Col>
                                          <Col sm="8">
                                              <div className="text-sm-end">
                                                  <Button
                                                    type="button"
                                                    color="success"
                                                    className="btn  mb-2 me-2"
                                                    onClick={upload}
                                                  >
                                                      <i className="fas fa-file-excel me-1" />
                                                      Export
                                                  </Button>
                                              </div>
                                          </Col>
                                      </Row>
                                      <BootstrapTable
                                        wrapperClasses="table-responsive"
                                        noDataIndication={() => <NoDataIndication />}
                                        striped={false}
                                        bordered={false}
                                        classes={"table align-middle table-nowrap"}
                                        headerWrapperClasses={"table-light"}
                                        hover
                                        pagination={paginationFactory(pageOptions)}
                                        {...toolkitProps.baseProps}
                                      />
                                  </div>
                                )}
                            </ToolkitProvider>
                        </Col>
                    </Row>
                ) : (
                  <div>
                      <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                      >
                          <Spinner type="grow" className="ms-6" color="primary" />
                      </div>
                      <h4
                        style={{ textAlign: "center", marginTop: "2%" }}
                        className="ms-6"
                      >
                          {" "}
                          En cours ...
                      </h4>
                  </div>
                )}
            </div>

            <ToastContainer
              transition={Slide}
              enableMultiContainer
              containerId={"A"}
              position={toast.POSITION.TOP_RIGHT}
              autoClose={2500}
            />
        </React.Fragment>
    )
}

export default withRouter(DataTableFicheRenseignement)
DataTableFicheRenseignement.propTypes = {
    orders: PropTypes.array,
    history: PropTypes.object,
}
